/**
 * Models pour les aventures - Identiques à Flutter
 */

export interface Adventure {
  idApi?: string;
  uniqueURI: string;
  name: string;
  type: string;
  theme: string;
  cardGFontTitle?: string;
  description?: string;
  imageUrl?: string; // URL réseau
  image?: string; // Base64 encodé
  content?: string; // JSON content (pour les aventures téléchargées)
  contentSize: number;
  version: number;
  difficulty?: string;
}

export interface ListAdventure {
  uniqueURI: string;
  name: string;
  type: string;
  theme: string;
  cardGFontTitle?: string;
  description?: string;
  imageUrl?: string; // URL réseau (pour les aventures non téléchargées)
  image?: string; // Base64 encodé (pour les aventures téléchargées)
  content?: string;
  contentSize: number;
  version: number;
  localVersion?: number; // Transient, non stocké
  difficulty?: string;
}

export const ListAdventureFromAdventure = (adventure: Adventure, localVersion?: number): ListAdventure => {
  // Extraire l'image base64 du content si disponible
  let imageBase64 = adventure.image;
  if (!imageBase64 && adventure.content) {
    try {
      const contentJson = JSON.parse(adventure.content);
      imageBase64 = contentJson.image as string | undefined;
    } catch (e) {
      console.error('[ListAdventure] Failed to parse content JSON:', e);
    }
  }

  return {
    uniqueURI: adventure.uniqueURI,
    name: adventure.name,
    type: adventure.type,
    theme: adventure.theme,
    cardGFontTitle: adventure.cardGFontTitle,
    description: adventure.description,
    imageUrl: adventure.imageUrl,
    image: imageBase64,
    content: adventure.content,
    contentSize: adventure.contentSize,
    version: adventure.version,
    localVersion,
    difficulty: adventure.difficulty,
  };
};
